import { GetToken, LoadedClerk } from '@clerk/types';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { i18n } from 'i18next';
import * as React from 'react';

import { Toaster } from '@repo/ui/components/ui/sonner.tsx';

import type { AppConfig } from '~/main.tsx';

export interface AppRouteContext {
  i18n: i18n;
  clerk: LoadedClerk;
  appConfig: AppConfig;
  getToken: GetToken;
}

export const Route = createRootRouteWithContext<AppRouteContext>()({
  component: RootComponent,
});

function RootComponent() {
  return (
    <React.Fragment>
      <Outlet />
      <Toaster richColors />
    </React.Fragment>
  );
}
